import { useEffect } from "react";

// Utils
import { SignalRStripePaymentFlowResponse } from "@/main/models/common/signalRReceiveUpdatesResponse";
import { StripePaymentFlowProgressEnum } from "@/main/services/enum/StripePaymentFlowProgressEnum";
import { isNullUndefined } from "@/main/services/utils";

interface HubItemStripePaymentFlowProps {
	data: SignalRStripePaymentFlowResponse[];
	customProps?: {
		onPaymentCompleted?: () => void;
	};
}

const COMPLETED_PROGRESS_STATUS = [
	StripePaymentFlowProgressEnum.CheckoutSessioncompleted,
	StripePaymentFlowProgressEnum.PaymentSuccessfull,
];

const HubItemStripePaymentFlow = ({ data, customProps }: HubItemStripePaymentFlowProps) => {
	const formattedData = isNullUndefined(data) ? [] : data;
	const onPaymentCompleted = customProps?.onPaymentCompleted;

	useEffect(() => {
		const lastItemSignalR = formattedData[formattedData.length - 1];
		if (isNullUndefined(lastItemSignalR)) return;

		const isPaymentCompleted = COMPLETED_PROGRESS_STATUS.includes(lastItemSignalR.progressStatus);
		if (!isPaymentCompleted) return;

		onPaymentCompleted?.();
	}, [JSON.stringify(formattedData)]);

	return <></>;
};

export default HubItemStripePaymentFlow;
